import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=ebb1621a&scoped=true&"
import script from "./contact.vue?vue&type=script&lang=js&"
export * from "./contact.vue?vue&type=script&lang=js&"
import style0 from "./contact.vue?vue&type=style&index=0&id=ebb1621a&prod&scoped=true&lang=css&"
import style1 from "./contact.vue?vue&type=style&index=1&id=ebb1621a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebb1621a",
  null
  
)

export default component.exports